import userNavigationTemplate from './userNavigationTemplate.html';
import userNavigationElementTemplate from './userNavigationElement.html';

const userNavigation = {
    bindings: {
        content: '@',
        firstName: '@'
    },
    template: userNavigationElementTemplate,

    controller: function($scope, $ionicPopover) {

        this.popover = $ionicPopover.fromTemplate(userNavigationTemplate, { scope: $scope });
        this.openPopover = ($event) => {
          this.popover.show($event);
        };

        this.closePopover = () => {
          this.popover.hide();
        };
        //Cleanup the popover when we're done with it!
        $scope.$on('$destroy', () => {
          this.popover.remove();
        });
        // Execute action on hide popover
        $scope.$on('popover.hidden', () => {
          // Execute action
        });
        // Execute action on remove popover
        $scope.$on('popover.removed', () => {
          // Execute action
        });

    }
};

export default userNavigation;



/** WEBPACK FOOTER **
 ** ./src/app/directives/popovers/userNavigation.js
 **/